var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--products"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "join-container"
  }, [_c('div', {
    staticClass: "join-complete"
  }, [_c('i', {
    staticClass: "icon icon-handshake"
  }), _c('h3', {
    staticClass: "join-complete__title"
  }, [_vm._v("회원가입이 완료 되었습니다.")]), _c('p', {
    staticClass: "join-complete__text mt-8 mt-md-14 white-space-pre-line"
  }, [_vm._v(_vm._s(_vm.description))]), _c('v-btn', {
    staticClass: "mt-16 mt-md-28",
    attrs: {
      "x-large": "",
      "color": "primary"
    }
  }, [_vm._v(" 메인으로 이동 ")])], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }